export const noopArr = []

export const noopObj = {}

export const Noop = () => null
